import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  card: {
    maxWidth: '100%',
    marginTop: '1.25rem',
  },
  title: {
    fontSize: 16,
    padding: '.75rem',
  },
  cardContent: {
    padding: '.75rem',
    '@media(max-width: 600px)': {
      padding: '1.5rem 0.5rem',
    },
  },
}));
